import React from 'react'
import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'
import {generateHelpLink} from '@daedalus/core/src/customerSupport/business'
import {BrandType} from '@daedalus/core/src/brand/types'
import Heading from '../../../../designSystem/Heading'
import ExternalLink from '../../../../../foundation/icons/ExternalLink'

interface Props {
  /** Brand configuration */
  brand: BrandType
}

const Wrapper = styled('a')(
  ({theme}) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    text-decoration: none;
    color: ${theme.colors.defaultTextColor};

    &:hover,
    &:visited,
    &:focus {
      text-decoration: none;
      color: ${theme.colors.defaultTextColor};
    }
  `
)

const GetHelpLink = ({brand}: Props) => {
  const getHelpLink = generateHelpLink(brand)

  return (
    <Wrapper href={getHelpLink} target="_blank" rel="noopener noreferrer">
      <Heading appearance="title3" marginBottomSize="s000">
        <FormattedMessageWrapper id="getHelp" defaultMessage="Get Help" />
      </Heading>
      <ExternalLink />
    </Wrapper>
  )
}

export default GetHelpLink
